import { Component } from '@angular/core';
import { HelperService } from 'src/app/shared/helpers/helper.service';

@Component({
  selector: 'app-owner-privacy-policy',
  templateUrl: './owner-privacy-policy.component.html',
  styleUrl: './owner-privacy-policy.component.scss'
})
export class OwnerPrivacyPolicyComponent {

  constructor(public helperService: HelperService) {}

  privacyPolicyLastUpdated: string =  '14th July 2026';

}
